export default "__VITE_ASSET__3fdf0d56__"